const STORAGE_KEY = 'cart-reservation-timer';

function getTimerState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function setTimerState(state) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    // Ignore storage errors (private mode, disabled storage).
  }
}

function clearTimerState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Ignore storage errors (private mode, disabled storage).
  }
}

function bindCartReset() {
  if (window.__cartReservationTimerResetBound) return;
  window.__cartReservationTimerResetBound = true;

  document.addEventListener('cart:change', (event) => {
    if ((event.detail?.cart?.item_count || 0) === 0) {
      clearTimerState();
    }
  });

  if (document.querySelector('cart-drawer .empty-state')) {
    clearTimerState();
  }
}

bindCartReset();

if (!customElements.get('cart-reservation-timer')) {
  customElements.define(
    'cart-reservation-timer',
    class CartReservationTimer extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('[data-timer-text]');
        this.textTemplate = this.dataset.text || '';
        this.durationMs = Math.max(1, Number(this.dataset.minutes) || 13) * 60 * 1000;
        this.designMode = this.dataset.designMode === 'true';

        const state = this.ensureState();
        if (!state) {
          this.hideTimer();
          return;
        }

        this.startTime = state.startTime;
        this.durationMs = state.durationMs;
        this.showTimer();
        this.tick();
        this.timer = setInterval(() => this.tick(), 250);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      ensureState() {
        const existing = getTimerState();

        if (existing?.expired) {
          return null;
        }

        if (existing?.startTime) {
          if (existing.startTime + existing.durationMs <= Date.now()) {
            setTimerState({ ...existing, expired: true });
            return null;
          }

          return existing;
        }

        const nextState = {
          startTime: Date.now(),
          durationMs: this.durationMs,
          expired: false,
        };
        setTimerState(nextState);
        return nextState;
      }

      tick() {
        const remaining = this.startTime + this.durationMs - Date.now();

        if (remaining <= 0) {
          this.expire();
          return;
        }

        this.render(remaining);
      }

      render(remaining) {
        const totalSeconds = Math.max(0, Math.ceil(remaining / 1000));
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        const timeLabel = `${minutes}:${seconds}`;
        const elapsed = this.durationMs - remaining;
        const progress = Math.min(100, Math.max(0, (elapsed / this.durationMs) * 100));

        if (this.textEl) {
          this.textEl.textContent = this.textTemplate.split('[timer]').join(timeLabel);
        }

        this.style.setProperty('--progress', `${progress}%`);
      }

      expire() {
        if (this.timer) clearInterval(this.timer);
        this.render(0);
        setTimerState({
          startTime: this.startTime,
          durationMs: this.durationMs,
          expired: true,
        });

        if (!this.designMode) this.hideTimer();
      }

      showTimer() {
        this.hidden = false;
      }

      hideTimer() {
        this.hidden = true;
      }
    }
  );
}
